'use strict';

var getCookie = require('./get-cookie');

module.exports = function(data, options) {

    var names = options.names || [];

    var cookieData = names.reduce(function(res, name) {
        res[name] = getCookie(name);
        return res;
    }, {});

    var newData = Object.assign({}, data);

    if(!newData.yola) {
        newData.yola = {};
    }
    newData.yola = Object.assign(newData.yola, cookieData);

    return newData;
};
